var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"clip-path":"url(#clip0_274_30484)"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"11","stroke":"none","stroke-width":"2"}})]),_vm._v(" "),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_274_30484"}},[_c('rect',{attrs:{"width":"24","height":"24"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }